import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  &.red {
    fill: ${({ theme }) => theme.colors.errorRed};
  }
`;

export const WarningIcon = (props) => (
  <SVG
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 512 512"
  >
    <path d="M256,82.752c-95.52,0-173.248,77.712-173.248,173.248S160.48,429.248,256,429.248c95.536,0,173.248-77.712,173.248-173.248  S351.52,82.752,256,82.752z M273.632,152.096l-4.4,151.296h-21.44l-4.4-151.296H273.632z M258.512,368  c-11.024,0-18.592-8.512-18.592-19.552c0-11.344,7.872-19.536,18.592-19.536c11.344,0,18.592,8.192,18.592,19.536  C277.104,359.488,269.856,368,258.512,368z" />
  </SVG>
);

export const WarningIconOutline = (props) => (
  <svg {...props} width="24" height="21" xmlns="http://www.w3.org/2000/svg">
    <g fill="#2B73C7" fillRule="nonzero">
      <path d="m11.253 12.27-.219-3.329c-.043-.67-.267-1.751.235-2.296.382-.418 1.286-.49 1.56.09.234.682.285 1.414.15 2.123l-.292 3.426a2.74 2.74 0 0 1-.205.937.58.58 0 0 1-.512.323.58.58 0 0 1-.518-.312 3.202 3.202 0 0 1-.2-.963zm.756 4.572a1.027 1.027 0 0 1-1.011-.978c-.03-.547.36-1.024.894-1.09a1.01 1.01 0 0 1 .962.442c.215.319.238.733.06 1.074a1.016 1.016 0 0 1-.905.552z" />
      <path d="M21.477 20.21H2.523a2.564 2.564 0 0 1-2.186-1.29 2.554 2.554 0 0 1 0-2.534l9.487-15.18a2.564 2.564 0 0 1 4.357.008l9.473 15.154c.456.785.462 1.753.014 2.544a2.565 2.565 0 0 1-2.19 1.299zM11.271 2.085l-9.487 15.18a.85.85 0 0 0 .74 1.256h18.953a.855.855 0 0 0 .73-1.275L12.728 2.084a.864.864 0 0 0-1.458 0z" />
    </g>
  </svg>
);

export const WarningIconTriangle = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_74_1921)">
      <path d="M12 3.75C12.5469 3.75 13.0547 4.0625 13.3281 4.53125L21.7656 18.9062C22.0391 19.4141 22.0391 20 21.7656 20.4688C21.4922 20.9766 20.9844 21.25 20.4375 21.25H3.5625C2.97656 21.25 2.46875 20.9766 2.19531 20.4688C1.92188 20 1.92188 19.4141 2.19531 18.9062L10.6328 4.53125C10.9062 4.0625 11.4141 3.75 12 3.75ZM12 8.75C11.4531 8.75 11.0625 9.17969 11.0625 9.6875V14.0625C11.0625 14.6094 11.4531 15 12 15C12.5078 15 12.9375 14.6094 12.9375 14.0625V9.6875C12.9375 9.17969 12.5078 8.75 12 8.75ZM13.25 17.5C13.25 16.8359 12.6641 16.25 12 16.25C11.2969 16.25 10.75 16.8359 10.75 17.5C10.75 18.2031 11.2969 18.75 12 18.75C12.6641 18.75 13.25 18.2031 13.25 17.5Z" fill="#727272" />
    </g>
    <defs>
      <clipPath id="clip0_74_1921">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WarningIcon;
